import { createContext, useContext, useState, useEffect, useCallback } from 'react';
import api from '../api/client';

const AuthContext = createContext(null);

export function AuthProvider({ children }) {
  const [user, setUser] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const token = localStorage.getItem('token');
    if (!token) { setLoading(false); return; }
    api.get('/auth/me')
      .then(r => setUser(r.data.user))
      .catch(() => localStorage.removeItem('token'))
      .finally(() => setLoading(false));
  }, []);

  const login = useCallback(async (email, password) => {
    const { data } = await api.post('/auth/login', { email, password });

    // OTP gerekiyorsa hata fırlatma — LoginPage bunu handle eder
    if (data.requires_otp) {
      const err = new Error('OTP required');
      err.otpData = data;
      throw err;
    }

    localStorage.setItem('token', data.token);
    setUser(data.user);
    return data.user;
  }, []);

  // OTP doğrulandıktan sonra token set edilmişse user'ı yükle
  const loadUser = useCallback(async () => {
    try {
      const r = await api.get('/auth/me');
      setUser(r.data.user);
      return r.data.user;
    } catch {
      localStorage.removeItem('token');
      setUser(null);
      return null;
    }
  }, []);

  const logout = useCallback(() => {
    localStorage.removeItem('token');
    setUser(null);
  }, []);

  return (
    <AuthContext.Provider value={{ user, loading, login, loadUser, logout }}>
      {children}
    </AuthContext.Provider>
  );
}

export const useAuth = () => useContext(AuthContext);
